export default __webpack_public_path__ + "static/media/headerLogo.6486f643.svg";